module.exports = __webpack_public_path__ + "static/media/Reason.d5fdfa79.svg";